import {
  getEmployeeIdFromToken,
  getJwtPayload,
  getTenantIdFromToken,
  getUserEmailFromToken,
} from "./jwt";

export function getAuthenticatedEmployeeId() {
  return getEmployeeIdFromToken();
}

export function getAuthenticatedTenantId() {
  return getTenantIdFromToken();
}

export function getAuthenticatedUserEmail() {
  return getUserEmailFromToken();
}

export function getAuthenticatedUserInitials() {
  const email = getAuthenticatedUserEmail();
  if (!email) return "?";

  const localPart = email.split("@")[0] ?? "";
  if (!localPart) return "?";

  const parts = localPart
    .split(/[._-]+/)
    .map((part) => part.trim())
    .filter(Boolean);

  if (parts.length >= 2) {
    return `${parts[0][0] ?? ""}${parts[1][0] ?? ""}`.toUpperCase();
  }

  return localPart.slice(0, 2).toUpperCase();
}

export { getEmployeeIdFromToken, getJwtPayload };
